import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, FileCheck2 } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { gov } from '../../lib/govApi';
import { portalPath } from '../../lib/portal';
import { toast } from '../../hooks/use-toast';

const GovApprovals = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    gov.orders({ awaiting_my_approval: true })
      .then((r) => setOrders(r.data || []))
      .catch((e) => {
        const d = e?.response?.data?.detail;
        const msg = Array.isArray(d) ? d.map((x) => x?.msg || JSON.stringify(x)).join('; ')
          : (typeof d === 'string' ? d : (e?.message || 'Failed to load pending approvals'));
        toast({ title: 'Approvals load failed', description: msg, variant: 'destructive' });
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-4" data-testid="gov-approvals-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-800">Pending Approvals</h1>
        <p className="text-sm text-slate-500">Orders waiting on your decision.</p>
      </div>

      <Card className="border-2">
        <CardContent className="p-0">
          {loading ? (
            <div className="flex items-center justify-center py-12"><Loader2 className="h-8 w-8 animate-spin text-blue-700" /></div>
          ) : orders.length === 0 ? (
            <div className="py-12 text-center">
              <FileCheck2 className="h-12 w-12 mx-auto text-emerald-300 mb-2" />
              <p className="text-slate-500">All caught up — no pending approvals.</p>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-slate-50">
                  <tr>
                    <th className="text-left p-3">Order</th>
                    <th className="text-left p-3">PO #</th>
                    <th className="text-left p-3">Agency</th>
                    <th className="text-left p-3">Purchaser</th>
                    <th className="text-left p-3">Total</th>
                    <th className="text-left p-3">Level</th>
                    <th className="text-left p-3">Submitted</th>
                    <th className="text-left p-3"></th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map(o => (
                    <tr key={o.order_id} className="border-t hover:bg-slate-50" data-testid={`approval-row-${o.order_id}`}>
                      <td className="p-3 font-medium">{o.order_id}</td>
                      <td className="p-3">{o.po_number || '—'}</td>
                      <td className="p-3 text-slate-600">{o.agency_name}</td>
                      <td className="p-3 text-slate-600">{o.purchaser_name}</td>
                      <td className="p-3 font-semibold text-blue-700">${Number(o.total).toFixed(2)}</td>
                      <td className="p-3 text-slate-600">{o.current_level} of {(o.approvals || []).length}</td>
                      <td className="p-3 text-slate-500">{new Date(o.created_at).toLocaleString()}</td>
                      <td className="p-3"><Link to={portalPath(`/orders/${o.order_id}`)} className="text-blue-700 underline" data-testid={`approval-review-${o.order_id}`}>Review</Link></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default GovApprovals;
